import React, { Suspense, lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import styled from 'styled-components/macro';
import { toastr } from 'react-redux-toastr';

import PrivateRoute from 'components/PrivateRoute';
import Notifications from 'components/Notifications';
import { Actions, ICountry } from 'reducers/app';
import { getRecaptchaConfig, getTips, getCountries } from 'api/catalogs';
import { ymapsKey } from 'config/yandexMaps';
import BlockedScreen, { BlockedScreen as Spinner } from 'components/BlockedScreen';
import AuthPage from 'pages/AuthPage';

const RouteWrapper = styled.div`
  padding-bottom: 20px;
`;

const HomePage = lazy(() => import('pages/HomePage'));

interface IProps {
  tipsSave: (tips: any) => void;
  configRecapthaSave: any;
  setCountries: (countries: ICountry[]) => void;
}

class App extends React.Component<IProps> {
  public componentDidMount() {
    getRecaptchaConfig().then((res: any) => {
      if (res.success) this.props.configRecapthaSave(res.data);
    }).finally(() => {
      this.fetchTips();
    });
  }

  public fetchTips = () => {
    getTips().then((response: any) => {
      if (response.success) {
        this.props.tipsSave(response.data);
      }
    });
  };

  public fetchCountries = () => {
    getCountries().then((response: any) => {
      if (response.success) {
        return this.props.setCountries(response.data);
      }
      toastr.error("", "Ошибка загрузки стран провайдеров");
    });
  };

  public render() {
    const url = `https://api-maps.yandex.ru/2.1?apikey=${ymapsKey}&lang=ru_RU`;

    return (
      <React.Fragment>
        <Helmet>
          <script src={url} type='text/javascript'></script>
        </Helmet>
        <Suspense fallback={<Spinner isVisible={true}/>}>
          <Switch>
            <Redirect exact={true} from="/" to="/home"/>
            <Route path={'/auth'} component={AuthPage}/>
            <RouteWrapper>
              <PrivateRoute path={'/home'} component={HomePage}/>
            </RouteWrapper>
          </Switch>
        </Suspense>
        <BlockedScreen/>
        <Notifications/>
      </React.Fragment>
    );
  }
}

const actions = {
  tipsSave: Actions.tipsSave,
  configRecapthaSave: Actions.configRecapthaSave,
  setCountries: Actions.setCountries,
};

export default connect(null, actions)(App);
